import { FC, useState, useEffect } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import Button from '@/components/UI/Button';
import { BenefitsIcon1, BenefitsIcon2, BenefitsIcon3, BenefitsIcon4, BenefitsIcon5, BenefitsIcon6, LockIcon } from '@/components/UI/svg/Membership';
import { signupCookie } from '@/utils/cookies/signupCookie';

const EuBenefits: FC<{
    isLogin?: boolean;
}> = ({ isLogin }) => {
    const { useLang, useRouter, Link, gtm } = useGlobal();
    const { locale, route } = useRouter();
    const { t } = useLang('membership.benefits');

    const list = [
        {
            icon: <BenefitsIcon1 />,
            title: t('benefitsicon1_title'),
            desc: t('benefitsicon1_desc'),
        },
        {
            icon: <BenefitsIcon2 />,
            title: t('benefitsicon2_title'),
            desc: t('benefitsicon2_desc'),
        },
        {
            icon: <BenefitsIcon3 />,
            title: t('benefitsicon3_title'),
            desc: t('benefitsicon3_desc'),
        },
        {
            icon: <BenefitsIcon4 />,
            title: t('benefitsicon4_title'),
            desc: t('benefitsicon4_desc'),
        },
        {
            icon: <BenefitsIcon5 />,
            title: t('benefitsicon5_title'),
            desc: t('benefitsicon5_desc'),
        },
        {
            icon: <BenefitsIcon6 />,
            title: t('benefitsicon6_title'),
            desc: t('benefitsicon6_desc'),
        },
    ];

    const priceList = [
        {
            title: t('exampleprice_title1'),
            price: t('exampleprice_price1'),
            save: '',
            color: '',
        },
        {
            title: t('exampleprice_title2'),
            price: t('exampleprice_price2'),
            save: t('exampleprice_save2'),
            color: '#FF7F00',
        },
        {
            title: t('exampleprice_title3'),
            price: t('exampleprice_price3'),
            save: t('exampleprice_save3'),
            color: '#F8200C',
        },
    ];

    return (
        <div className={styled.benefits} id="EcoCredits_Benefits">
            <h5 className="benefits_title">{t('title')}</h5>
            <div className="benefits_example">
                <p className="example_title_mobile">{t('example_title')}</p>
                <p className="example_desc_mobile">{t('example_desc')}</p>
                <div>
                    <div className="example_left">
                        <NextImage
                            src={require(`@publicLocal/ecocredits/membership_product.png`)}
                            alt={t('example_left_msg')}
                            aria-label={t('example_left_msg')}
                        />
                        <p>{t('example_left_msg')}</p>
                    </div>
                    <div className="example_right">
                        <p className="example_title_pc">{t('example_title')}</p>
                        <p className="example_desc_pc">{t('example_desc')}</p>
                        <div className="example_price">
                            {priceList.map((item) => (
                                <div key={item.title} className="example_price_item">
                                    <p className="example_item_title">{item.title}</p>
                                    <p className="example_item_desc">{item.price}</p>
                                    {item.save && (
                                        <span className="example_item_save" style={{ background: item.color }}>
                                            {item.save}
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                        <p className="example_tips_pc">{t('example_tips')}</p>
                    </div>
                </div>
                <p className="example_tips_mobile">{t('example_tips')}</p>
            </div>
            {/* pc */}
            <div className="benefits_iconlist_pc">
                {list.map((item) => (
                    <div key={item.title} className="benefits_icon_item">
                        <div className="benefits_icon">{item.icon}</div>
                        <div className="benefits_introduce">
                            <p className="introduce_title">{item.title}</p>
                            <p className="introduce_desc">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
            {/* mobile */}
            <Swiper
                className="benefits_iconlist_mobile"
                modules={[Pagination]}
                pagination
                spaceBetween={16}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {list?.map((item) => (
                    <SwiperSlide key={item.title} className="benefits_icon_item">
                        <div className="benefits_icon">{item.icon}</div>
                        <div className="benefits_introduce">
                            <p className="introduce_title">{item.title}</p>
                            <p className="introduce_desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {!isLogin && (
                <div className="benefits_btn">
                    <Link
                        href={`/${locale}/register?redirect=${encodeURIComponent(`/${locale}${route}#EcoCredits_Benefits`)}`}
                        onClick={() => {
                            signupCookie?.({
                                sector_name: t('title'),
                                entry_position: 3,
                            });
                        }}
                    >
                        <Button
                            type="link"
                            className="login_btn"
                            onClick={() =>
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_button',
                                    page_name: 'membership',
                                    list_name: 'Redeem EcoCredits Rewards',
                                    button_name: t('benefits_register_btn'),
                                    function: 'Unlock',
                                })
                            }
                        >
                            <LockIcon /> {t('benefits_register_btn')}
                        </Button>
                    </Link>
                </div>
            )}
        </div>
    );
};

export default EuBenefits;
